// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"471e8b2182087f6bee6f","293":"6d856ba43412de5500a8","518":"6462d897c03142ab4ca6","779":"73f6d3339c86709709c5"}[chunkId] + ".js";
};